import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';
import { blOrderInvoicesKey } from './use-bl-order-invoices';
import { allocatedDownpaymentKey } from './use-allocated-downpayment';
import type { InvoiceRow } from '../types';

export interface CancelInvoiceMutationArgs {
  readonly invoiceId: string;
  readonly orderId: string;
  readonly blOrderId?: string | undefined;
}

export function useCancelInvoiceMutation(args: CancelInvoiceMutationArgs) {
  const qc = useQueryClient();
  return useMutation<InvoiceRow, Error, string>({
    mutationFn: (cancel_reason) =>
      apiRequest<InvoiceRow>(`/invoices/${encodeURIComponent(args.invoiceId)}/cancel`, {
        method: 'POST',
        body: { cancel_reason },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['order-advance-invoices', args.orderId] });
      void qc.invalidateQueries({ queryKey: ['order-invoices', args.orderId] });
      if (args.blOrderId !== undefined) {
        void qc.invalidateQueries({ queryKey: blOrderInvoicesKey(args.blOrderId) });
        void qc.invalidateQueries({ queryKey: allocatedDownpaymentKey(args.blOrderId) });
        void qc.invalidateQueries({ queryKey: ['bl-order-detail'] });
      }
    },
  });
}
